import { render } from "./ProgramTrade.vue?vue&type=template&id=17b6c51f&ts=true"
import script from "./ProgramTrade.vue?vue&type=script&lang=ts"
export * from "./ProgramTrade.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__